'use client';

/**
 * RelatedVendorDetailsCard — the vendor riding alongside a product
 * selection, stacked in the rail without a second click.
 *
 * A cost-plan line's product ↔ vendor is 1:1, so selecting a line's
 * product (costplan-lines-card.tsx's `selectLine`) also stashes that
 * line's vendor in `graph-selection-store.relatedVendor`. This card
 * just reads it and reuses `DetailsCard` with explicit props — the
 * same relocation mechanism already built for the Ask-overlay pin
 * case, not a new fetch path.
 *
 * Self-suppresses (renders nothing) when there's no related vendor —
 * e.g. the current selection is a vendor group itself (no "related"
 * vendor distinct from the selection), or nothing is selected at all.
 * Deliberately NOT symmetric: a vendor selection never gets a related
 * *product* card, because one vendor supplies several lines on a
 * plan — there's no single product to pick.
 *
 * @see klyde_edge/klyde_ipe/lib/stores/graph-selection-store.ts — relatedVendor
 * @see costplan-lines-card.tsx — selectLine
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain copilot
 */

import { useGraphSelectionStore } from '@/lib/stores/graph-selection-store';
import { DetailsCard } from './details-card';

export function RelatedVendorDetailsCard() {
  const relatedVendor = useGraphSelectionStore((s) => s.relatedVendor);
  if (!relatedVendor) return null;
  return <DetailsCard entityType="vendor" entityId={relatedVendor.id} />;
}
